import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Button from "../components/ds/Button";
import Checkbox from "../components/ds/Checkbox";
import Icon from "../components/ds/Icon";
import Message from "../components/ds/Message";
import Modal from "../components/ds/Modal";
import Overlay from "../components/ds/Overlay";
import RowTag from "../components/RowTag";
import TableFooter from "../components/TableFooter";
import { massiveSelect } from "../modules/table";
import { tagService } from "../container";
import { useGlobalState } from '../state';

export default function Tags() {
  const [searchParams] = useSearchParams();
  const { media } = useGlobalState();
  const [massiveRemove, setMassiveRemove] = useState(false);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const loadTags = async (filters) => {
    setLoading(true);

    try {
      const tags = await tagService.search({
        media_id: media.id,
        ...filters,
      });

      setTags(tags);
    } catch (err) {
      toast.error('Ocurrió un error al cargar los tags.');
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    const filters = {
      title: searchParams.get('title'),
      state: searchParams.get('state'),
    };

    loadTags(filters);
  }, [searchParams, media]);

  const updateTag = async (tag) => {
    setUpdating(true);

    try {
      await tagService.update(tag.id, {
        title: tag.title,
      });

      loadTags();

      toast.success('Tag actualizado.');
    } catch (err) {
      toast.error('Ocurrió un error al actualizar el tag.');
      console.error(err);
    }

    setUpdating(false);
  };

  const approveTag = async (tagId) => {
    try {
      await tagService.approve(tagId);

      loadTags();

      toast.success('Tag aprobado.');
    } catch (err) {
      toast.error('Ocurrió un error al aprobar el tag.');
      console.error(err);
    }
  };

  const rejectTag = async (tagId) => {
    try {
      await tagService.reject(tagId);

      loadTags();

      toast.success('Tag rechazado.');
    } catch (err) {
      toast.error('Ocurrió un error al rechazar el tag.');
      console.error(err);
    }
  };

  const deleteTag = async () => {
    toast.error('El tag no puede eliminarse.');
  };

  if (loading) {
    return <span>Loading...</span>;
  }

  return (
    <>
      <h1 className="t-heading-xl-cms">Tags</h1>

      <div id="content">
        <div className="table">
          <div className="head">
              <div className="row">
                <div className="col-6">
                  <Checkbox onchange={massiveSelect} />
                  <p>Nombre</p>
                </div>

                <div className="col-3">
                  <p>Estado</p>
                </div>
              </div>
          </div>

          <div className="body">
            {tags && tags.map((tag) => (
              <RowTag
                key={tag.id}
                tag={tag}
                loading={updating}
                onUpdate={updateTag}
                onApprove={approveTag}
                onReject={rejectTag}
                onDelete={deleteTag}
              />
            ))}
          </div>

          <TableFooter total={tags.length}>
            <li onClick={() => setMassiveRemove(true)}><Icon icon="trash" />Eliminar</li>
          </TableFooter>
        </div>
      </div>

      {massiveRemove && (
        <Overlay>
          <Modal title="Eliminar tags" onclose={() => setMassiveRemove(false)}>
            <Message type="warning" description={`Seguro que quieres eliminar estos tags? Esta acción no se puede deshacer.`} />

            <Button type="destructive" label="Eliminar" onclick={() => {}} />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
